'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pacomo = require('utils/pacomo');

var _reactIntl = require('react-intl');

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    Can be hidden/shown by toggling classname `is-visible`,
    which will also toggle the overlay.
*/
var NavModal = function NavModal(_ref) {
    var ui = _ref.ui,
        updateUI = _ref.updateUI;

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)({ 'is-visible': ui.navModalIsVisible }),
            tabIndex: '-1',
            role: 'dialog' },
        _react2.default.createElement('div', { className: 'overlay' }),
        _react2.default.createElement(
            'div',
            { className: 'modal-dialog', role: 'document' },
            _react2.default.createElement(
                'div',
                { className: 'modal-content' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-header' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navModal.header',
                        defaultMessage: 'You have unsaved changes!' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'modal-body' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'navModal.message',
                        defaultMessage: 'Are you sure you want to navigate away from this page? You will lose any unsaved changes.' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'modal-footer' },
                    _react2.default.createElement(
                        'button',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navModal.buttonYes',
                            defaultMessage: 'Yes' })
                    ),
                    _react2.default.createElement(
                        'button',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'navModal.buttonNegative',
                            defaultMessage: 'No' })
                    )
                )
            )
        )
    );
};

exports.default = (0, _reduxUi2.default)()((0, _pacomo.pacomoTransformer)(NavModal));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/NavModal.js
// module id = 1316
// module chunks = 0